import * as banSlice from "../store/banSlice";
import BanDialog from "./banDialog";
import BanHistoryDialog from "./banHistoryDialog";
import BannedDevicesTable from "../components/bannedDevicesTable";
import ModalMessage from "./modalMessage";
import OverlayLoader from "../components/overlayLoader";
import React from "react";
import TableSelectionManager from "../components/tableSelectionManager";
import TooltipButtonGroup from "../components/tooltipButtonGroup";
import TooltipElement from "../components/tooltipElement";
import { connect } from "react-redux";

import "./common.css";

const thatObjectName = "bannedDevices";

class BanContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showBanDialog: false,
      banDialogMode: BanDialog.Mode.Edit,
      showHistoryDialog: false,
    };
  }

  componentDidMount() {
    this.props.fetchBannedDevices();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Banned devices</h1>
          {this.renderButtons()}
          {this.renderContent()}
          {this.renderBanDialog()}
          {this.renderHistoryDialog()}
          {this.renderModalMessage()}
        </div>
      </OverlayLoader>
    );
  }

  renderModalMessage = () => <ModalMessage />;

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement
        type="button"
        text="Refresh"
        icon="refresh"
        onClick={this.props.fetchBannedDevices}
      />
      <TooltipElement
        type="button"
        text="Add banned device"
        icon="plus"
        onClick={this.createBannedDevice}
        displayOnlyForWriter
      />
      <TooltipElement
        type="button"
        text="Edit banned device"
        icon="edit"
        onClick={this.editBannedDevice}
        disabled={this.isEditeditBannedDeviceDisabled()}
        displayOnlyForWriter
      />
      <TooltipElement
        type="button"
        text="Show banned device history"
        icon="list-alt"
        onClick={this.showHistoryDialog}
        disabled={this.isHistoryButtonDisabled()}
      />
    </TooltipButtonGroup>
  );

  renderContent = () => {
    const { bannedDevicesFetchingError, bannedDevices } = this.props;

    if (bannedDevicesFetchingError) {
      return this.renderError(bannedDevicesFetchingError.toString());
    }

    return (
      <TableSelectionManager items={bannedDevices} objectName={thatObjectName}>
        <BannedDevicesTable bannedDevices={bannedDevices} />
      </TableSelectionManager>
    );
  };

  renderBanDialog = () => (
    <BanDialog
      mode={this.state.banDialogMode}
      id={this.getSelectedBannedDeviceFieldValue("id")}
      banStatus={this.getSelectedBannedDeviceFieldValue("banStatus")}
      onClose={this.closeBanDialog}
      show={this.state.showBanDialog}
    />
  );

  closeBanDialog = () => {
    this.setState({ showBanDialog: false });
  };

  createBannedDevice = () => {
    this.setState({
      banDialogMode: BanDialog.Mode.Create,
      showBanDialog: true,
    });
  };

  editBannedDevice = () => {
    this.setState({
      banDialogMode: BanDialog.Mode.Edit,
      showBanDialog: true,
    });
  };

  isEditeditBannedDeviceDisabled = () => this.props.selectedBannedDevice.length !== 1

  renderHistoryDialog = () => (
    <BanHistoryDialog
      show={this.state.showHistoryDialog}
      onClose={this.closeHistoryDialog}
      id={this.getSelectedBannedDeviceFieldValue("id")}
    />
  );

  showHistoryDialog = () => {
    this.setState({ showHistoryDialog: true });
  };

  closeHistoryDialog = () => {
    this.setState({ showHistoryDialog: false });
  };

  isHistoryButtonDisabled = () => this.props.selectedBannedDevice.length !== 1

  getSelectedBannedDeviceFieldValue = (fieldName, defaultValue = null) => {
    const bannedDevice = this.props.selectedBannedDevice[0];

    if (!bannedDevice) {
      return null;
    }

    try {
      const value = fieldName.
        split(".").
        reduce((acc, key) => acc[key], bannedDevice);
      return value === undefined ? defaultValue : value === null ? defaultValue : value;
    } catch (e) {
      return defaultValue;
    }
  };

  isLoading = () => this.props.isbannedDevicesFetching;

  getLoaderMessage = () => "Ban devices loading...";
}

const mapStateToProps = (state) => ({
  bannedDevices: banSlice.banSelectors.selectAll(state),
  isbannedDevicesFetching: banSlice.banSelectors.isFetching(state),
  bannedDevicesFetchingError: banSlice.banSelectors.fetchingError(state),
  selectedBannedDevice: banSlice.banSelectors.selectedBannedDevice(state),
});

const actionCreators = {
  fetchBannedDevices: banSlice.fetchBannedDevices,
};

export default connect(mapStateToProps, actionCreators)(BanContainer);



// WEBPACK FOOTER //
// ./src/containers/banContainer.js